var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon--telegram",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8004 2.40039C20.7236 2.40092 20.6473 2.4125 20.5738 2.43477C20.5522 2.44064 20.5308 2.44742 20.5098 2.45508L2.9207 8.04883V8.05195C2.6082 8.16857 2.40084 8.46684 2.40039 8.80039C2.40098 9.07977 2.54728 9.3386 2.78633 9.4832L8.13164 13.7238L18.6988 5.30195L10.277 15.8691L14.5145 21.2113C14.6589 21.4525 14.9193 21.6002 15.2004 21.6004C15.5339 21.5999 15.8322 21.3926 15.9488 21.0801H15.952L21.5504 3.47539C21.5561 3.45942 21.5613 3.44326 21.566 3.42695C21.5883 3.35347 21.5999 3.27717 21.6004 3.20039C21.6004 2.75856 21.2422 2.40039 20.8004 2.40039L20.8004 2.40039Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon--telegram.e9ea674dbd60946e29f1bdc2a6326cb5.svg";
export { ForwardRef as ReactComponent };